import { createStore, createHook, createActionsHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		shouldShowSpotlight: false,
	},
	actions: {
		setShouldShowSpotlight:
			(shouldShowSpotlight: boolean) =>
			({ setState }) => {
				setState({ shouldShowSpotlight });
			},
	},
	name: 'share-nudge-spotlight-store',
});

export const useShareNudgeSpotlightStore = createHook(Store);
export const useShareNudgeSpotlightActions = createActionsHook(Store);
